import { useContext } from "react";
import { useLazyQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { IParams } from "@models/IParams";
import { AppContext } from "../context/EditSessionsContext";
import { Types } from "../context/formData.reducer";
import { BLOCKING_THRESHOLD_QUERY } from "../graphql/blockingThreshold.query";

// Canonical loader for `state.form.blockingThreshold`. Three call sites are
// intentional: `FormEdit` fires it on mount so the listing (CHS-2516) can
// derive per-session lock state, `Repeat` fires it as a defensive refresh
// while also consuming `loading` to render its local spinner, and
// `EditSessionLayout` fires it on mount so the Programming-tab gate does not
// depend on tab-mount order. Anything that needs to populate the threshold must
// use this hook — do not re-inline the `useLazyQuery` +
// `Types.SetBlockingThreshold` dispatch elsewhere.
export const useLoadBlockingThreshold = () => {
  const { scenario }: IParams = useParams();
  const { dispatch } = useContext(AppContext);
  const [load, { loading }] = useLazyQuery(BLOCKING_THRESHOLD_QUERY, {
    onCompleted(data) {
      dispatch({
        type: Types.SetBlockingThreshold,
        payload: data?.data?.blockingThreshold?.current_datetime ?? null,
      });
    },
  });
  return {
    loadBlockingThreshold: () => load({ variables: { scenarioId: scenario } }),
    loading,
  };
};
